import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    email: '',
    apellido: '',
    nombre: '',
    admin: false,
    rowVersion: null,
    
    usuarioDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_USUARIO'(state, usuarioId) {
        state.id = usuarioId;
        state.email = '';
        state.apellido = '';
        state.nombre = '';
        state.admin = false;
        state.rowVersion = null;
    },
    'SET_USUARIO'(state, usuario) {
        state.email = usuario.email;
        state.apellido = usuario.apellido;
        state.nombre = usuario.nombre;
        state.admin = (/true/i).test(usuario.admin);
        state.rowVersion = usuario.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.usuarioDatos = [];
    },
    'SET_USUARIO_DATOS' (state, datos) {
        state.usuarioDatos = datos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, usuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_USUARIO', usuarioId);

            if (usuarioId != 0) {
                apiAxios.get(`usuarios/${usuarioId}/abm` ) 
                    .then(res => {
                        commit('SET_USUARIO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let usuario= {
                apellido: state.apellido.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                admin: (/true/i).test(state.admin),
                rowVersion: state.rowVersion
            }

            apiAxios.post(`usuarios/${state.id}`, usuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, usuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (usuarioId != 0) {
                apiAxios.get(`usuarios/${usuarioId}`) 
                .then(res => {
                    let datos = [
                        { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        { 'nombre': 'nombreCompleto', 'campo': 'Nombre', 'valor': res.data.nombreCompleto, 'formato': '' },
                        { 'nombre': 'admin', 'campo': 'Administrador', 'valor': (res.data.admin) ? 'Si' : 'No', 'formato': '' },
                    ];

                    commit('SET_USUARIO_DATOS', datos);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },

    activar ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`usuarios/${usuarioId}/activar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    inactivar ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`usuarios/${usuarioId}/inactivar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    resetPassword ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('usuarios/reset-password', params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    forgotPassword ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`usuarios/${usuarioId}/forgot`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    preregistrar ( {}, params ) {
        return new Promise((resolve, reject) => { 
          apiAxios.post('usuarios/preregister', params)
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    sendInvite ( {}, usuarioId ) {
        return new Promise((resolve, reject) => { 
          apiAxios.post(`usuarios/${usuarioId}/send-invite`)
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
          reject(error);
        })
    },    
    logout ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`usuarios/${usuarioId}/logout`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}